export default __webpack_public_path__ + "static/media/ecommerce.11f9ff6d.png";